import { useState } from 'react';
import { bookingAPI } from '../services/api';

export const useBooking = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const createBooking = async (bookingData) => {
        try {
            setLoading(true);
            setError(null);
            const response = await bookingAPI.createBooking(bookingData);
            setSuccess(response.data.bookingId);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to create booking');
            console.error('Error creating booking:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const trackBooking = async (bookingId) => {
        try {
            setLoading(true);
            setError(null);
            const response = await bookingAPI.trackBooking(bookingId);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to track booking');
            console.error('Error tracking booking:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const getCustomerBookings = async (email) => {
        try {
            setLoading(true);
            setError(null);
            const response = await bookingAPI.getCustomerBookings(email);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch bookings');
            console.error('Error fetching bookings:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const cancelBooking = async (id, email) => {
        try {
            setLoading(true);
            setError(null);
            const response = await bookingAPI.cancelBooking(id, email);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to cancel booking');
            console.error('Error canceling booking:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        createBooking,
        trackBooking,
        getCustomerBookings,
        cancelBooking,
        loading,
        error,
        success,
        setError
    };
};